import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from '../../config/axios';
import { send } from 'emailjs-com';

import AuthContext from '../../contexts/AuthContext';

import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import ErrorNotice from '../../components/UI/ErrorNotice/ErrorNotice';
import { updateObject, checkValidity, generatePassword } from '../../utilities/utilities';

// import authData from '../../config/authData';

import classes from './Register.module.scss';

const Register = props => {
    const auth = useContext(AuthContext)[0];

    const TABS_IN_FORM = 5;
    const [tab, setTab] = useState(1);

    const onPersonalDataShowHandler = () => {
        props.setModalContent({ title: 'Personal Data Administration Information Clause', fetch: 'personal-data' });
        props.showModal(true);
    }

    const [state, setState] = useState({
        controls: {
            header1: {
                tab: 1,
                element: 'header',
                header: 'Personal data',
                valid: true
            },
            info1: {
                tab: 1,
                element: 'info',
                icon: false,
                type: 'small',
                comment: 'All required fileds are marked with *.',
                valid: true
            },
            firstName: {
                tab: 1,
                element: 'input',
                dependsOn: null,
                type: 'text',
                label: 'First name *',
                placeholder: 'First name',
                value: '',
                valid: false,
                validation: {
                    required: true,
                    minLength: 1
                },
                errorMessage: 'This field must be non-empty',
                touched: false,
                ref: useRef()
            },
            lastName: {
                tab: 1,
                element: 'input',
                dependsOn: null,
                type: 'text',
                label: 'Last name *',
                placeholder: 'Last name',
                value: '',
                valid: false,
                validation: {
                    required: true,
                    minLength: 1
                },
                errorMessage: 'This field must be non-empty',
                touched: false,
                ref: useRef()
            },
            email: {
                tab: 1,
                element: 'input',
                dependsOn: null,
                label: 'E-mail *',
                placeholder: 'Your e-mail',
                value: '',
                valid: false,
                validation: {
                    required: true,
                    isEmail: true
                },
                errorMessage: 'Proper e-mail address required',
                touched: false,
                ref: useRef()
            },
            affiliation: {
                tab: 1,
                element: 'input',
                dependsOn: null,
                type: 'text',
                label: 'Affiliation *',
                placeholder: 'Your affiliation',
                value: '',
                valid: false,
                validation: {
                    required: true,
                    minLength: 1
                },
                errorMessage: 'This field must be non-empty',
                touched: false,
                ref: useRef()
            },
            header2: {
                tab: 2,
                element: 'header',
                header: 'Conference participation',
                valid: true
            },
            participation: {
                tab: 2,
                element: 'select',
                dependsOn: null,
                options: [
                    { value: '', displayValue: 'Select participation type *' }
                ],
                value: '',
                valid: false,
                validation: {
                    required: true,
                    minLength: 1
                },
                errorMessage: 'Please, select one',
                touched: false,
                ref: useRef()
            },
            section: {
                tab: 2,
                element: 'select',
                dependsOn: null,
                options: [
                    { value: '', displayValue: 'Select preferred thematic section *' },
                ],
                value: '',
                valid: false,
                validation: {
                    required: true,
                    minLength: 1
                },
                errorMessage: 'Please, select one',
                touched: false,
                ref: useRef()
            },
            infoText: {
                tab: 2,
                element: 'editor',
                label: 'Additional info',
                rows: 3,
                type: 'editor',
                value: '',
                placeholder: 'Some addintional info',
                valid: true,
                validation: {
                    required: false
                },
                errorMessage: '',
                ref: useRef()
            },
            header3: {
                tab: 3,
                element: 'header',
                header: 'Talk info',
                valid: true
            },
            info3: {
                tab: 3,
                element: 'info',
                icon: false,
                comment: 'Fill only if plan to speak. If not known yet, the title and abstract can be sent by e-mail. For math text in the title and abstract, only $math$ and $$math$$ are allowed. Please do not use custom macros.',
                valid: true
            },
            title: {
                tab: 3,
                element: 'textarea',
                dependsOn: null,
                rows: 2,
                label: 'Title',
                placeholder: 'Talk title (plain text / LaTeX)',
                value: '',
                valid: true,
                // validation: {
                //     required: false,
                //     minLength: 1
                // },
                errorMessage: 'This field shall be non-empty',
                touched: false,
                ref: useRef()
            },
            abstract: {
                tab: 3,
                element: 'textarea',
                dependsOn: null,
                rows: 5,
                label: 'Abstract',
                placeholder: 'Your abstract (plain text / LaTeX). Please, use only $math$ and $$math$$.',
                value: '',
                valid: true,
                // validation: {
                //     required: false,
                //     minLength: 1
                // },
                errorMessage: 'This field shall be non-empty',
                touched: false,
                ref: useRef()
            },
            header4: {
                tab: 4,
                element: 'header',
                header: 'Proceedings',
                valid: true
            },
            info4: {
                tab: 4,
                element: 'info',
                icon: false,
                comment: 'Please, check the checkbox if you would like to publish an article in the conference proceedings. The CMK2020 conference proceedings are planned to be published with De Gruter Sciendo. The publication is supported by the Ministry of Science and Higher Education, and is free of charge for authors. The expected publishing date is the third quarter of 2021. All papers are expected to have DOI number, and the book will be ISBN registered',
                valid: true
            },
            proceedings: {
                tab: 4,
                element: 'checkbox',
                dependsOn: null,
                rows: 2,
                type: 'checkbox',
                label: 'Proceedings publication',
                value: '',
                valid: true,
                validation: {
                    required: false,
                },
                errorMessage: 'This field shall be non-empty',
                touched: false,
                ref: useRef()
            },
            articleTitle: {
                tab: 4,
                element: 'textarea',
                dependsOn: 'proceedings',
                rows: 2,
                label: 'Article title',
                placeholder: 'The planned article title',
                value: '',
                valid: true,
                // validation: {
                //     required: false,
                //     minLength: 1
                // },
                errorMessage: 'This field shall be non-empty',
                touched: false,
                ref: useRef()
            },
            header5: {
                tab: 5,
                element: 'header',
                header: 'Personal Data Consent *',
                valid: true
            },
            info5: {
                tab: 5,
                element: 'info',
                icon: false,
                comment: 'In accordance with the Regulation of the European Parliament and of the Council (EC) 2016/679 of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC – General Data Protection Regulation GDPR (EU Journal of Laws of 2016, No. 119, Item 1). I hereby give my consent for the processing of my personal data by the Jan Kochanowski University in Kielce, ul. Żeromskiego 5, 25-369 Kielce, Poland in order to perform any activities related to implementation of the Contemporary Mathematics in Kielce 2020 conference and I declare that all information about my personal data are consistent with the facts.',
                valid: true
            },
            consent: {
                tab: 5,
                element: 'checkbox',
                dependsOn: null,
                rows: 2,
                type: 'checkbox',
                label: <div className={classes.CheckboxText}>I have read the contents of  <span onClick={onPersonalDataShowHandler}>Personal Data Administration Information Clause.</span></div>,
                value: false,
                valid: false,
                validation: {
                    required: true,
                },
                errorMessage: 'To proceed you shall agree',
                touched: false,
                ref: useRef()
            },
        },
        formIsValid: false
    });
    const [loading, setLoading] = useState(true);
    const [displayErrorNotice, setDisplayErrorNotice] = useState(false);
    // const [auth, setAuth] = useState(null);

    useEffect(() => {
        const getSections = axios.get(`/sections.json?auth=${auth.token}`);
        const getParticipationTypes = axios.get(`/participations.json?auth=${auth.token}`);
        // const authorize = axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=AIzaSyDLmUJLhu3Z8sosomrmLJjFVnrLV81-IME', authData)

        // const getPersonalDataRules = axios.get('personal-data.json');
        Promise.all([getSections, getParticipationTypes])
            .then(response => {
                let updatedControls = null;
                const res1 = response[0].data;
                const res2 = response[1].data;
                // const res3 = response[2].data;

                const loadedSections = Object.keys(res1)
                    .map(key => ({
                        value: key,
                        displayValue: res1[key].section
                    }))
                const currentSections = state.controls.section.options.concat(loadedSections);

                const loadedParticipations = Object.keys(res2)
                    .map(key => ({
                        value: key,
                        displayValue: res2[key].participation
                    }))
                const currentParticipations = state.controls.participation.options.concat(loadedParticipations);

                updatedControls = {
                    ...state.controls,
                    participation: {
                        ...state.controls.participation,
                        options: currentParticipations
                    },
                    section: {
                        ...state.controls.section,
                        options: currentSections
                    }
                }
                setState({ controls: updatedControls, formIsValid: false });
                // setAuth(res3);
                setLoading(false);

            })
            .catch(error => {
                setLoading(false);
            })
    }, [])

    const editorChangeHandler = (controlName, val) => {
        let updatedControls = null;
        updatedControls = updateObject(state.controls, {
            [controlName]: updateObject(state.controls[controlName], {
                value: val,
                valid: checkValidity(state.controls[controlName].value, state.controls[controlName].type, state.controls[controlName].validation),
                touched: true
            })
        })

        let isFormValid = true;
        for (let controlName in updatedControls) {
            isFormValid = updatedControls[controlName].valid && isFormValid;
        }

        setState({ controls: updatedControls, formIsValid: isFormValid });
    }

    const inputChangedHandler = (eventType, controlName) => {
        let updatedControls = null;
        switch (eventType) {
            case 'checkbox':
                updatedControls = updateObject(state.controls, {
                    [controlName]: updateObject(state.controls[controlName], {
                        value: state.controls[controlName].ref.current.checked,
                        valid: checkValidity(state.controls[controlName].ref.current.checked, state.controls[controlName].type, state.controls[controlName].validation),
                        touched: true
                    })
                })
                break;
            default:
                updatedControls = updateObject(state.controls, {
                    [controlName]: updateObject(state.controls[controlName], {
                        value: state.controls[controlName].ref.current.value,
                        valid: checkValidity(state.controls[controlName].ref.current.value, state.controls[controlName].type, state.controls[controlName].validation),
                        touched: true
                    })
                })
        }

        let isFormValid = true;
        for (let controlName in updatedControls) {
            isFormValid = updatedControls[controlName].valid && isFormValid;
        }

        setState({ controls: updatedControls, formIsValid: isFormValid });
    }

    const form = Object.keys(state.controls)
        .map(key => ({
            id: key,
            data: state.controls[key]
        }))
        .filter(el => el.data.tab === tab)
        .map(el => {
            return <Input
                key={el.id}
                id={el.id}
                data={el.data}
                disabled={el.data.dependsOn ? state.controls[el.data.dependsOn].value : true}
                changed={el.data.type !== 'editor' ? inputChangedHandler : editorChangeHandler} />
        });


    const onPrevTebHandler = () => {
        const updatedTab = Math.max(tab - 1, 1);
        setTab(updatedTab);
    }

    const onNextTebHandler = () => {
        const updatedTab = Math.min(tab + 1, TABS_IN_FORM);
        setTab(updatedTab);
    }

    const onSubmitHandler = () => {

        if (state.formIsValid) {
            setDisplayErrorNotice(false);
            const updatedState = Object.fromEntries(
                new Map(
                    Object.keys(state.controls).map(
                        key => {
                            return [key, state.controls[key].value]
                        })
                )
            );

            setLoading(true);
            const now = new Date();
            const pass = generatePassword(10);

            const postData = axios.post(`/users.json?auth=${auth.token}`, {
                ...updatedState,
                date: `${now.getTime()}`,
                active: false
            })

            const register = axios.post('https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyDLmUJLhu3Z8sosomrmLJjFVnrLV81-IME', {
                email: state.controls.email.value,
                password: pass,
                returnSecureToken: true
            })

            const message = `We kindly inform that you have successfully registered for the Contemporary Mathematics in Kielce 2020 conference. Your schedule access email is the email you have registered with, while the password is: "${pass}". The conference schedule will be available just before the Conferecne starts. Please keep this email for future purposes.`;
            const sendEmail = send('cmk2020kielce', 'template_8tbs6pg', {
                to_name: `${state.controls.firstName.value} ${state.controls.lastName.value}`,
                email: state.controls.email.value,
                message: message
            }, 'user_6X92arM1mrohrouXaDjrT')

            Promise.all([postData, register, sendEmail])
                .then(_ => {
                    setLoading(false);
                    props.history.push("/notice", { type: 'success', message: 'You have successfuly register for CMK 2020 Conference. Please, check your mail for confirmation and CMK2020 webpage login data.' });
                })
                .catch(error => {
                    props.history.push("/notice", { type: 'failed', message: `Something went wrong :( Please, contact the conference Organizers. ${error.message}` });
                })
        } else {
            setDisplayErrorNotice(true);
        }
    }

    return <div className={classes.Right}>
        <h1>Register</h1>
        {displayErrorNotice ? <ErrorNotice>Please, fill all reqired fields</ErrorNotice> : null}
        {!loading
            ? <form className="Form">
                {form}
            </form>
            : <Spinner />
        }

        {/* <span onClick={onModalShowHandler}>accept</span> */}
        <div className={tab > 1 ? classes.Buttons : classes.ButtonsRight}>
            {tab > 1 && <Button type="cancel" clicked={onPrevTebHandler}>Previous</Button>}
            <Button type="cancel" clicked={tab === TABS_IN_FORM ? onSubmitHandler : onNextTebHandler}>
                {tab === TABS_IN_FORM ? 'Register' : 'Next'}
            </Button>
        </div>
    </div>
}

export default Register;